


























































import {
  apiBasicZoneLocationGetDistrictInfo,
  apiMerchantStoreGetCommodityDeliveryFee,
  apiShoppingCartList,
  apiTradeGeneralTradePreOrder,
  ApiTradeGeneralTradePreOrderRequest,
} from '@/api'
import { asRequiredDeep, sum, wait } from 'vtils'
import { computed, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import {
  defineClassComponent,
  useActivated,
  useApiPlus,
  useHandler,
} from '@/hooks'
import { instantDeliveryBus } from '../bus'
import { logg, submit } from '@/utils'
import { mall } from '@/mall_jssdk'
import { navigateTo } from '@/router'
import { showCart } from '../utils'

export default defineClassComponent<{
  martId: string
}>(
  {
    props: ['martId'],
  },
  ({ props }) =>
    class {
      constructor() {
        useActivated(() =>
          instantDeliveryBus.on('refreshCart', () => {
            this.apiData.refresh()
          }),
        )
      }

      id = `x${Date.now()}`

      apiData = useApiPlus(
        {
          cartData: () =>
            apiShoppingCartList(
              {},
              {
                businessChannel: props.martId,
              },
            )
              .then(asRequiredDeep)
              .then(async res => {
                const { longitude, latitude } = await dcb
                  .getLocation()
                  .catch(() => ({} as any))
                logg('计算邮费-获取到的经纬度', {
                  经度: longitude,
                  纬度: latitude,
                })
                const { districtCode } =
                  await apiBasicZoneLocationGetDistrictInfo({
                    lng:
                      (longitude < 0.1 ? 0 : longitude) || (undefined as any),
                    lat:
                      (latitude < 0.1 ? 0 : latitude) || (undefined as any),
                  })
                const deliveryFeeData =
                  await apiMerchantStoreGetCommodityDeliveryFee({
                    districtCode: districtCode,
                    storeId: props.martId,
                    totalNumber: sum(
                      res.validList.map(item => item.quantity),
                    ),
                    totalWeight: sum(
                      res.validList.map(
                        item => (item.weight || 0) * item.quantity,
                      ),
                    ),
                  })
                return {
                  ...res,
                  deliveryFeeData: deliveryFeeData,
                }
              }),
        },
        {
          refreshOnActivated: true,
        },
      )

      cartData = computed(() => this.apiData.data?.cartData?.validList || [])

      deliveryFeeData = computed(
        () =>
          this.apiData.data?.cartData?.deliveryFeeData || {
            price: 0,
            minDeliveryPrice: 0,
          },
      )

      totalGoods = computed(() => this.cartData.value.length)

      totalMoney = computed(() => {
        return mall.calculator.add(_ =>
          this.cartData.value.map(item => _.mul(item.price, item.quantity)),
        )
      })

      totalCostMoney = computed(() => {
        return mall.calculator.add(_ =>
          this.cartData.value.map(item =>
            _.mul(item.dashPrice, item.quantity),
          ),
        )
      })

      canOrder = computed(
        () =>
          this.totalMoney.value >=
          this.deliveryFeeData.value.minDeliveryPrice,
      )

      canOrderDiff = computed(() =>
        mall.calculator.sub(
          this.deliveryFeeData.value.minDeliveryPrice,
          this.totalMoney.value,
        ),
      )

      destroyCart = ref<() => any>()

      handleServiceClick = useHandler<'购物车' | '立即下单'>({
        购物车: () => {
          if (!document.querySelector(`#${this.id}`)) {
            this.destroyCart.value = showCart({
              martId: props.martId,
              id: this.id,
            })
          } else {
            this.destroyCart.value?.()
          }
        },
        立即下单: () => {
          submit(async $ => {
            $.start()
            const { validList: cartData } = await apiShoppingCartList(
              {},
              {
                businessChannel: props.martId,
              },
            ).then(asRequiredDeep)
            if (!cartData.length) {
              return $.fail('请先选择商品')
            }
            const preOrderRequestData: ApiTradeGeneralTradePreOrderRequest = {
              preOrderType: '1',
              skuInfo: cartData.map(item => ({
                commodityId: item.commodityId,
                count: item.quantity,
                skuId: item.skuId,
                sellChannelId: item.sellChannelId,
              })),
            }
            const data = await apiTradeGeneralTradePreOrder(
              preOrderRequestData,
            )
            this.destroyCart.value?.()
            await wait(0)
            navigateTo('InstantDeliveryOrderPlace', {
              type: 'normal',
              data: JSON.stringify(data),
              preOrderRequestData: JSON.stringify(preOrderRequestData),
            })
          })
        },
      })
    },
)
